import { AppBundle } from 'api/optimalprint-sdk.d';

type AbstractProductAttribute =
  AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.ProductItem.IAttribute;
type ProductItem = AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem;

const productMatchAttributes = (product: ProductItem, attributesToMatch: AbstractProductAttribute[]) =>
  !attributesToMatch.some((attribute) => {
    const attrMatch = (product.product.attributes || []).find(
      (productAttribute) =>
        productAttribute.typeName === attribute.typeName && productAttribute.value === attribute.value,
    );
    return !attrMatch;
  });

export default productMatchAttributes;
